import { useState } from "react";
import { Container, Row, Col, Carousel, Modal, Image } from "react-bootstrap";
import { FaGraduationCap } from "react-icons/fa";
import certificate1 from "../../Assets/microsoft.jpg";
import certificate2 from "../../Assets/photo_2025-11-05 11.25.23.jpeg";
import certificate3 from "../../Assets/photo_2025-11-05 11.25.26.jpeg";
import certificate4 from "../../Assets/AlgoExpert.jpeg";
import certificate5 from "../../Assets/linkeedin.jpg";
import certificate6 from "../../Assets/google.jpg";

function Education() {
  const certificates = [
    certificate1,
    certificate2,
    certificate3,
    certificate4,
    certificate5,
    certificate6,
  ];

  // բաժանում ենք 3-ական խմբերի
  const chunkSize = 3;
  const slides = [];
  for (let i = 0; i < certificates.length; i += chunkSize) {
    slides.push(certificates.slice(i, i + chunkSize));
  }

  // Fullscreen modal-ի state
  const [showModal, setShowModal] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);

  const handleShow = (cert) => {
    setSelectedCert(cert);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  return (
    <Container fluid className="education-section" id="education">
      <Container>
        {/* Header */}
        <Row>
          <Col md={12} className="education-header text-center">
            <h1>
              My <span className="purple">Education</span> Journey 🎓
            </h1>
            <p className="edu-subtitle">
              A quick look at my academic background and certifications
            </p>
          </Col>
        </Row>

        {/* Education Cards */}
        <Row className="mt-4">
          <Col md={6} className="education-card">
            <div className="edu-box fancy-border text-center p-4">
              <div className="edu-icon-wrapper mb-3">
                <FaGraduationCap size={45} className="edu-icon purple" />
              </div>
              <h3 className="purple">Morpho Academy</h3>
              <p className="edu-year">2025 – 2026</p>
            </div>
          </Col>

          <Col md={6} className="education-card">
            <div className="edu-box fancy-border text-center p-4">
              <div className="edu-icon-wrapper mb-3">
                <FaGraduationCap size={45} className="edu-icon purple" />
              </div>
              <h3 className="purple">Armenian Code Academy</h3>
              <p className="edu-year">3 Months</p>
            </div>
          </Col>

          <Col md={6} className="education-card">
            <div className="edu-box fancy-border text-center p-4">
              <div className="edu-icon-wrapper mb-3">
                <FaGraduationCap size={45} className="edu-icon purple" />
              </div>
              <h3 className="purple">Picsart Academy</h3>
              <p className="edu-year">2026 – 2026</p>
            </div>
          </Col>

          <Col md={6} className="education-card">
            <div className="edu-box fancy-border text-center p-4">
              <div className="edu-icon-wrapper mb-3">
                <FaGraduationCap size={45} className="edu-icon purple" />
              </div>
              <h3 className="purple">Full Learning</h3>
              <p className="edu-year">4 Months</p>
            </div>
          </Col>
        </Row>

        {/* Certificates */}
        <Row className="mt-5">
          <Col md={12}>
            <h2 className="purple mb-4 text-center">Certificates 🏅</h2>
            <Carousel
              indicators={false}
              controls={true}
              fade={false}
              interval={3000}
              pause="hover"
            >
              {slides.map((slideCerts, idx) => (
                <Carousel.Item key={idx}>
                  <Row className="justify-content-center">
                    {slideCerts.map((cert, index) => (
                      <Col
                        md={4}
                        sm={6}
                        xs={12}
                        className="mb-3 text-center"
                        key={index}
                      >
                        <img
                          src={cert}
                          alt={`Certificate ${index + 1}`}
                          className="w-100 rounded-4 shadow certificate-img"
                          style={{
                            height: "300px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => handleShow(cert)}
                        />
                      </Col>
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>

        {/* Fullscreen Modal */}
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          size="xl"
          className="certificate-modal"
        >
          <Modal.Body className="p-0 bg-dark text-center">
            <Image
              src={selectedCert}
              alt="Full Certificate"
              fluid
              className="w-100"
              style={{ maxHeight: "90vh", objectFit: "contain" }}
            />
          </Modal.Body>
        </Modal>
      </Container>
    </Container>
  );
}

export default Education;
